import { render, staticRenderFns } from "./CaptureArea.vue?vue&type=template&id=d03f4a3c&scoped=true"
import script from "./CaptureArea.vue?vue&type=script&lang=js"
export * from "./CaptureArea.vue?vue&type=script&lang=js"
import style0 from "./CaptureArea.vue?vue&type=style&index=0&id=d03f4a3c&prod&lang=scss&scoped=true"
import style1 from "./CaptureArea.vue?vue&type=style&index=1&id=d03f4a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03f4a3c",
  null
  
)

export default component.exports